module.exports = __webpack_public_path__ + "static/media/read_content_aloud_manipuri.e1fba752.mp3";